import { PropsWithChildren } from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import {
  ProductFilters,
  ResponsiveFiltersWidget,
} from "src/pages/ProductPage/widgets";
import { ResponsiveProductSamplesWidget } from "src/widgets/ResponsiveProductSamplesWidget";

import css from "./PageLayout.module.scss";

export const PageLayout = ({ children }: PropsWithChildren) => {
  const { isDesktop } = useGravityDevice();

  return (
    <div className={css.layout}>
      <div className={css.filter}>
        <ResponsiveFiltersWidget />
        {isDesktop && <ProductFilters />}
      </div>
      <div className={css.container}>{children}</div>
      <ResponsiveProductSamplesWidget />
    </div>
  );
};
